/**
 * Mutable pricing constants. Defaults match the original hardcoded values.
 * Overridden at runtime from the `pricing_settings` table by loadPricingSettings().
 */
export const PRICING_CONSTANTS = {
  /** Cost per drawer surcharge above the shop-standard 1-drawer config */
  DRAWER_SURCHARGE: 40,
  /** Price per square inch for finished end panels (height × depth × rate) */
  PANEL_PRICE_PER_SQIN: 0.1017,
  /** Add-on to base panel price for decorative panels */
  DECORATIVE_PANEL_ADDON: 45,
  /** Island Back — functional cabinet doors on the back, per linear foot */
  ISLAND_BACK_CABINET_PRICE_PER_LF: 500,
  /** Island Back — decorative paneled / shiplap back (no doors), per linear foot */
  ISLAND_BACK_PANELED_PRICE_PER_LF: 350,
  /** Custom item estimator — price per square foot of developed box surface area */
  CUSTOM_ITEM_PRICE_PER_SQFT: 28,
};

/** Defaults snapshot used by "Reset to default" in the admin editor. */
export const PRICING_CONSTANTS_DEFAULTS = { ...PRICING_CONSTANTS };
